import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { setNotificationDialog } from 'Components/dialogs/state/actions';

import { setSiteDatePopupOpen } from 'PointOfSale/modules/setDateAndSite/state/action';
import PageHeaderComponent from 'PointOfSale/modules/layouts/component/PageHeader';
import {
  getHomeButtonDialogType,
  DIALOG_TYPES,
} from 'PointOfSale/helpers/homeButtonHelper';
import * as MealCounterActions from 'PointOfSale/modules/cepCard/state/actions';
import {
  BODY_FONT_SIZE,
  POS_ROUTES,
} from 'PointOfSale/modules/common/constants';
import * as CommonStateSelectors from 'State/selectors';
import * as POSSelectors from 'PointOfSale/selectors';
import { toggleFullscreen } from 'Common/UI/state/actions';

class PageHeader extends React.Component {
  state = {
    dialogIndex: 0,
    isFontLarge: false,
    type: DIALOG_TYPES.CONFIRM,
  };

  showSiteSetupPopup = () => {
    const { location, setSiteDatePopupOpen } = this.props;
    const currentPath = location.pathname;
    if (_.includes([POS_ROUTES.HOME, POS_ROUTES.SERVE_OPTIONS], currentPath)) {
      setSiteDatePopupOpen(true);
    }
  };

  changeFontSize = () => {
    document.documentElement.style.fontSize = !this.state.isFontLarge
      ? `${BODY_FONT_SIZE + 2}px`
      : `${BODY_FONT_SIZE}px`;
    this.setState({
      isFontLarge: !this.state.isFontLarge,
    });
  };

  goToHome = () => {
    const { history, toggleFullscreen } = this.props;
    toggleFullscreen(false);
    history.push('/home');
  };

  onHomeClick = () => {
    // Determine the proper dialog, some allow exit with simple confirmation, others do not
    switch (getHomeButtonDialogType(this.props)) {
      case DIALOG_TYPES.MEAL_COUNTER:
        this.props.setNotificationDialog({
          ...NOTIFICATION_DIALOG_MESSAGES.HOME_CONFIRM_SERVE_MEAL_COUNTER,
          functionsToRunOnOk: [this.goToHome],
        });
        break;
      case DIALOG_TYPES.INCOMPLETE:
        this.props.setNotificationDialog({
          ...NOTIFICATION_DIALOG_MESSAGES.HOME_CONFIRM_SERVE_INCOMPLETE_TRANSACTION,
        });
        break;
      case DIALOG_TYPES.CONFIRM:
      default:
        this.props.setNotificationDialog({
          ...NOTIFICATION_DIALOG_MESSAGES.HOME_CONFIRM_SERVE,
          functionsToRunOnOk: [this.goToHome],
        });
        break;
    }
  };

  render() {
    const {
      siteDate,
      selectedSiteDetails,
      online,
      toggleFullscreen,
      fullscreen,
      hasMealCounterSession,
      showServingStatus,
      profile,
    } = this.props;

    return (
      <React.Fragment>
        <PageHeaderComponent
          online={online}
          showSiteSetupPopup={this.showSiteSetupPopup}
          siteDate={siteDate}
          selectedSiteDetails={selectedSiteDetails}
          changeFontSize={this.changeFontSize}
          toggleFullscreen={toggleFullscreen}
          onHomeClick={this.onHomeClick}
          fullscreen={fullscreen}
          hasMealCounterSession={hasMealCounterSession}
          showServingStatus={showServingStatus}
          profile={profile}
        />
      </React.Fragment>
    );
  }
}

PageHeader.propTypes = {
  selectedSiteDetails: PropTypes.object,
};

const mapStateToProps = state => ({
  online:
    CommonStateSelectors.getOnline(state) &&
    CommonStateSelectors.getServerUp(state),
  fullscreen: CommonStateSelectors.getFullscreen(state),
  showServingStatus: CommonStateSelectors.getShowServingStatus(state),
  profile: POSSelectors.getProfile(state),
  siteDate: POSSelectors.getSelectedDate(state),
  selectedSiteDetails: POSSelectors.getSelectedSiteDetails(state),
  hasMealCounterSession: POSSelectors.hasMealCounterSession(state),
  isCurrentSessionMealCounter: POSSelectors.getIsCurrentSessionMealCounter(
    state
  ),
  hasUnprocessedMeals: POSSelectors.getHasUnprocessedMeals(state),
  hasBoughtItems: POSSelectors.getHasBoughtItems(state),
  hasPaidAmount: POSSelectors.getHasPaidAmount(state),
  hasTeacherStudentsSelected: POSSelectors.getHasTeacherStudentsSelected(state),
});

const mapDispatchToProps = {
  setSiteDatePopupOpen,
  mealCounterCheckout: MealCounterActions.checkout,
  toggleFullscreen,
  setNotificationDialog,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PageHeader)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/container/PageHeader.js